import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IMerchant } from '@interfaces/merchant.interface';
import { MatDialog } from '@angular/material';
import { EditAdminDialogComponent } from '@modules/super-admin/components/edit-admin-dialog/edit-admin-dialog.component';
import * as adminReducer from '@modules/super-admin/reducers';
import { ConfirmDialogComponent } from '@modules/shared/components/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { GetAllMerchants } from '@modules/super-admin/actions/merchants.actions';
import {ActivatedRoute, Router} from '@angular/router';
import {MerchantDetailService} from '@modules/super-admin/services/merchant-detail.service';
import _ from 'lodash';
import { MessengerService } from '@modules/messenger/messenger.service';
import { Location } from '@angular/common';

@Component({
  selector: 'edex-merchant-number',
  templateUrl: './merchant-number.component.html',
  styleUrls: ['./merchant-number.component.scss']
})
export class MerchantNumberComponent implements OnInit {

  displayedColumns: string[] = ['contactName', 'email', 'phoneNumberCall', 'companyName', 'status','transactions'];
  dataSource = new MatTableDataSource<IMerchant>([]);

  merchantStatus = '';
  search = '';
  debouncedFilter;
  payProcess = ['Payrix', 'Paypal', 'Stripe'];

  private merchantsSub: Subscription;
  public merchants$ = this.store.pipe(select(adminReducer.getMerchants));

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(    private store: Store<adminReducer.State>,
    private router: Router,
  private msgr: MessengerService,
  private route: ActivatedRoute,
    private merchantApiService: MerchantDetailService,
    public dialog: MatDialog,public location: Location) { }

  ngOnInit() {
    let userId = this.route.snapshot.paramMap.get('id');
      this.getMerchants(userId)
  }

  getMerchants(id) {
    let body = {
      SAreferenceNumber : id
    }
    this.merchantApiService.getSAMerchantById(body).subscribe(
      (merchants) => {
        this.dataSource = new MatTableDataSource<IMerchant>(merchants);
        this.dataSource.paginator = this.paginator;
        this.dataSource.paginator.pageIndex=0
      },
      (err) => {

      }
    );
  }

  GotoTransactions (merchant:any) {
    // if(merchant && this.payProcess.includes(merchant.paymentProcessor)) {
      this.router.navigateByUrl(`/salesagent-transaction/${merchant._id}`)
    // } else if(merchant && merchant.publicKey) {
    //   this.router.navigateByUrl(`/admin/full-transaction-history/${merchant.publicKey}`)
    // }
  }

  goToPage(merchant:any) {
    this.router.navigateByUrl(`/admin/users/merchant/${merchant._id}`)
  }

  // deactivateMerchant(event: Event, merchant: IMerchant) {
  //   event.stopPropagation();

  //   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //     data: {
  //       text: 'Are you sure to deactivate this merchant?'
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       this.merchantApiService.deactivateMerchant({
  //         id: merchant._id,
  //       }).subscribe(
  //         (data) => {
  //           this.getMerchants()
  //           this.msgr.message('User account deactivate')
  //         },
  //         (err) => {
  //           this.msgr.error('Something went wrong...');
  //         }
  //       );
  //     }
  //   });
  // }


  applyFilter() {
    this.router.navigate(['/admin/users/merchants'], {
      queryParams: {
        status: this.merchantStatus,
        search: this.search,
      },
    }).then();
  }

  ngOnDestroy() {
    if (this.merchantsSub) {
      this.merchantsSub.unsubscribe();
    }
  }
}
